import { useLayoutEffect, useRef } from 'react'

import { useI18n } from '../lib/i18n'
import { Icon } from './Icon'

/** The persistent research notice reserves its actual height, including wrapped text and safe areas. */
export function ResearchNotice() {
  const { t } = useI18n()
  const notice = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const element = notice.current!
    const root = document.documentElement
    const measure = () => root.style.setProperty('--banner-height', `${element.getBoundingClientRect().height}px`)
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(element, { box: 'border-box' })
    return () => {
      observer.disconnect()
      root.style.removeProperty('--banner-height')
    }
  }, [])

  return (
    <div ref={notice} className="research-banner" role="note">
      <Icon name="flask" />
      <span>{t('researchOnly')}</span>
    </div>
  )
}
